import {Action, ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';

import * as actionsUi from './funktionsbereich-checklisten.actions.ui';
import {
    GET_VERANSTALTUNG_FUNKTIONSBEREICHE_CHECKLISTEN,
    GET_VERANSTALTUNG_FUNKTIONSBEREICHE_CHECKLISTEN_ERFOLGREICH,
    GET_VERANSTALTUNG_FUNKTIONSBEREICHE_CHECKLISTEN_FEHLER,
    GetVeranstaltungFunktionsbereicheChecklistenAction,
    GetVeranstaltungFunktionsbereicheChecklistenErfolgreichAction,
    GetVeranstaltungFunktionsbereicheChecklistenFehlerAction
} from '../../../../client-ngrx/veranstaltungen';
import {
    PhasenVeranstaltungFunktionsbereiche,
    VeranstaltungStatus
} from '../../../../clients/veranstaltungen';
import { APP_RESET_ACTION } from '@orga-app/appstart/actions';
import {AKTUELLE_VERANSTALTUNG_SETZEN} from '../../app-state/actions/veranstaltung.actions';

export interface ModuleState {
    page: PageState;
}

export const reducers: ActionReducerMap<ModuleState> = {
    page: pageReducer
};

export interface PageState {
    phasenVeranstaltungFunktionsbereiche: Array<PhasenVeranstaltungFunktionsbereiche>;
    uiZeigePhasenVeranstaltungFunktionsbereicheLaden: boolean;
    uiZeigePhasenVeranstaltungFunktionsbereicheLadefehler: boolean;

    veranstaltungStatus: VeranstaltungStatus;
}

export const initialPageState: PageState = {
    phasenVeranstaltungFunktionsbereiche: null,
    veranstaltungStatus: null,
    uiZeigePhasenVeranstaltungFunktionsbereicheLaden: false,
    uiZeigePhasenVeranstaltungFunktionsbereicheLadefehler: false
};

export function pageReducer(state = initialPageState, action: Action): PageState {
    switch (action.type) {
        // APP RESET
        case APP_RESET_ACTION: {
            return Object.assign({}, state, <PageState> initialPageState);
        }


        // Page State Reset
        case actionsUi.PAGE_STATE_RESET: {
            const a = <actionsUi.PageStateResetAction> action;

            return Object.assign({}, state, <PageState> initialPageState);
        }

        case AKTUELLE_VERANSTALTUNG_SETZEN: {
            return Object.assign({}, state, <PageState> initialPageState);
        }

        // Veranstaltung => Funktionsbereiche und Checklisten
        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_CHECKLISTEN: {
            const a = <GetVeranstaltungFunktionsbereicheChecklistenAction> action;

            return Object.assign({}, state, <PageState> {
                uiZeigePhasenVeranstaltungFunktionsbereicheLaden: true,
                uiZeigePhasenVeranstaltungFunktionsbereicheLadefehler: false
            });
        }

        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_CHECKLISTEN_ERFOLGREICH: {
            const a = <GetVeranstaltungFunktionsbereicheChecklistenErfolgreichAction> action;

            // den veranstaltungsstatus für die darstellung suchen
            let vs: VeranstaltungStatus = null;
            if (a.payload.length > 0) {
                const x = a.payload.find(item => item.phase.phase_id === 'VERANSTALTUNG');
                if (x != null) {
                    vs = x.veranstaltung_status;
                }
            }

            return Object.assign({}, state, <PageState> {
                phasenVeranstaltungFunktionsbereiche: a.payload,
                uiZeigePhasenVeranstaltungFunktionsbereicheLaden: false,
                uiZeigePhasenVeranstaltungFunktionsbereicheLadefehler: false,
                veranstaltungStatus: vs
            });
        }

        case GET_VERANSTALTUNG_FUNKTIONSBEREICHE_CHECKLISTEN_FEHLER: {
            const a = <GetVeranstaltungFunktionsbereicheChecklistenFehlerAction> action;

            return Object.assign({}, state, <PageState> {
                phasenVeranstaltungFunktionsbereiche: [],
                veranstaltungStatus: null,
                uiZeigePhasenVeranstaltungFunktionsbereicheLaden: false,
                uiZeigePhasenVeranstaltungFunktionsbereicheLadefehler: true
            });
        }

        default: {
            return state;
        }
    }
}


/**
 * The createFeatureSelector function selects a piece of state from the root of the state object.
 * This is used for selecting feature states that are loaded eagerly or lazily.
 */
export const getModuleState = createFeatureSelector<ModuleState>('FunktionsbereicheChecklistenPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);

// DATA
export const getPhasenVeranstaltungFunktionsbereiche = createSelector(getPageState, (state: PageState) => {
    // state.phasenVeranstaltungFunktionsbereiche

    if (state.phasenVeranstaltungFunktionsbereiche === null || state.phasenVeranstaltungFunktionsbereiche === undefined) {
        return [];
    } else {
        const phasenVeranstaltungFunktionsbereicheWrapped = [...state.phasenVeranstaltungFunktionsbereiche];

        return phasenVeranstaltungFunktionsbereicheWrapped.map((item: PhasenVeranstaltungFunktionsbereiche) => {

            let funktionsbereiche = [...item.funktionsbereiche];

            funktionsbereiche = funktionsbereiche.map((fb) => {
                const checklisten = [...fb.checklisten].sort((a, b) => {
                    if (a && a.checkliste.titel && b && b.checkliste.titel && a.checkliste.titel.toLowerCase() < b.checkliste.titel.toLowerCase()) {
                        return -1;
                    }
                    if (a && a.checkliste.titel && b && b.checkliste.titel && a.checkliste.titel.toLowerCase() > b.checkliste.titel.toLowerCase()) {
                        return 1;
                    }
                    return 0;
                }).sort((a, b) => {
                    if (a.checkliste.reihenfolge < b.checkliste.reihenfolge) {
                        return -1;
                    }
                    if (a.checkliste.reihenfolge > b.checkliste.reihenfolge) {
                        return 1;
                    }
                    return 0;
                });

                return Object.assign({}, fb, {checklisten});
            });

            return Object.assign({}, item, {funktionsbereiche});
        });
    }

});
export const getUiZeigePhasenVeranstaltungFunktionsbereicheLaden = createSelector(getPageState, (state: PageState) => state.uiZeigePhasenVeranstaltungFunktionsbereicheLaden);
export const getUiZeigePhasenVeranstaltungFunktionsbereicheLadefehler = createSelector(getPageState, (state: PageState) => state.uiZeigePhasenVeranstaltungFunktionsbereicheLadefehler);

export const getVeranstaltungStatus = createSelector(getPageState, (state: PageState) => state.veranstaltungStatus);


